import React from "react"

// Data
import {
  SEVEN_DMP_FAQ_DATA,
  THIRTY_DMP_FAQ_DATA,
  NINETY_DCH_FAQ_DATA,
  MDP_FAQ_DATA,
  BFS_FAQ_DATA,
  HOT_ABS_FAQ_DATA,
  HWD_FAQ_DATA,
  HWD2_FAQ_DATA,
  LIONESS_FAQ_DATA,
  BGP_FAQ_DATA,
  FBC_FAQ_DATA,
  VP_FAQ_DATA,
  CP_FAQ_DATA,
  SC_FAQ_DATA,
  WS_FAQ_DATA,
  RR_FAQ_DATA,
  PERIMENOFIT_FAQ_DATA,
} from "../../../static/data/faqs"
import lazyLoad from "../../utilities/handleLazyLoad"

// Component
const FaqItem = lazyLoad(() => import("./FaqItem"))

/**
 * @param color - the color of the faq items
 * @param productName - product name
 * */
const Faqs = ({ color, productName }) => {
  /*============================
   CONTENT
  =============================*/
  const getData = () => {
    switch (productName) {
      case "7dmp":
        return SEVEN_DMP_FAQ_DATA
      case "30dmp":
        return THIRTY_DMP_FAQ_DATA
      case "90dch":
        return NINETY_DCH_FAQ_DATA
      case "mdp":
        return MDP_FAQ_DATA
      case "bfs":
        return BFS_FAQ_DATA
      case "hot-abs":
        return HOT_ABS_FAQ_DATA
      case "hwd":
        return HWD_FAQ_DATA
      case "hwd2":
        return HWD2_FAQ_DATA
      case "lioness":
        return LIONESS_FAQ_DATA
      case "bgp":
        return BGP_FAQ_DATA
      case "fbc":
        return FBC_FAQ_DATA
      case "vp":
        return VP_FAQ_DATA
      case "cp":
        return CP_FAQ_DATA
      case "sc":
        return SC_FAQ_DATA
      case "ws":
        return WS_FAQ_DATA
      case "rr":
        return RR_FAQ_DATA
      case "perimenofit":
        return PERIMENOFIT_FAQ_DATA
      default:
        return null
    }
  }

  const data = getData() || []

  return (
    <>
      {data && data.length ? (
        <div className={`faqs ${color ? `faqs--${color}` : ""}`}>
          {data.map((item, index) => (
            <FaqItem key={`faq-${index}`} item={item} />
          ))}
        </div>
      ) : null}
    </>
  )
}
export default Faqs
